import { useState, useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from '@mui/material/CircularProgress';
import Button from "@mui/material/Button";
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';

const getReportData = async (region) => {
  try{
    const regionNameReportId = {
      Australia: "be0acc90-85db-46dc-ba1c-a93a73635cd4",
      "United States": "46ee64e0-6122-4253-81c2-e1934ea60689",
      Asia: "391af397-0d55-4dde-a27d-63180483eade",
      Europe: "07a9cef1-9d6a-4c40-b6d8-a2fe2dd15df2"
      };

      const workspaceName = {
        Australia: "Aus_workspace",
        "United States": "US_workspace",
        Asia:"Asia_workspace",
        Europe: "Europe_workspace"
      }

    const reportId = regionNameReportId[region];
    const workspace = workspaceName[region];

    return {reportId, workspace}

  }catch(error){
    console.log("Error while fetching the report data necessary",error.message)
  }
} 
   

const PowerBiReports = ({region,assessementId,selectedScenario,projectName}) => {
    const { instance, accounts } = useMsal();
    const [accessToken, setAccessToken] = useState("");
    const [embedUrl, setEmbedUrl] = useState("");
    const [reportId, setReportId] = useState(""); 
    const [showDownloadButton, setShowDownloadButton] = useState(false)
    const [isDownloaded, setIsDownloaded] = useState(false)
    const [pdfDownloadURL, setPdfDownloadURl] = useState()
    const currentOrigin = window.location.origin;
    const currentPath = window.location.pathname;
    const redirectUri = currentOrigin + currentPath;

    // // For time calulations // //
    const timeStampRef = useRef(null);

    useEffect(() => {
      timeStampRef.current = performance.now();
    }, [selectedScenario]);

    const timeStampCalc = () => {
      const getTimeStamp = timeStampRef.current; 
      const endTime = performance.now();
      const loadTime = (endTime - getTimeStamp) / 1000; // Convert milliseconds to seconds
      return loadTime
    };
    // // For time calculations // //

    const getEmbedUrl = async () => {
    try {
        const {reportId} = await getReportData(region)

        const response = await fetch(`https://api.powerbi.com/v1.0/myorg/groups/38f13453-627c-4e82-aa37-01c7587e4624/reports/${reportId}`, {
            headers: {
                "Authorization": "Bearer " + accessToken
            },
            method: "GET"
        });

        const errorMessage = [];
        errorMessage.push("Error occurred while fetching the embed URL of the report");
        errorMessage.push("Request Id: " + response.headers.get("requestId"));

        const data = await response.json();

        if (response.ok) {
            return data["embedUrl"]
        } else {
            errorMessage.push("Error " + response.status + ": " + data.error.code);
            console.log(errorMessage);
        }
    } catch (error) {
        console.log(["Error in making the API call: " + error.message]);
    }
};

const authenticate = async () => {
  try {
      const isAuthenticated = accounts.length > 0;
      const loginRequest = {
          scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
          account: accounts[0],
          redirectUri: redirectUri // Set the redirect URL to the current origin
      };

      if (!isAuthenticated) {
          const response = await instance.acquireTokenRedirect(loginRequest);
          setAccessToken(response.accessToken);
      } else {
          try {
              const response = await instance.acquireTokenSilent(loginRequest);
              setAccessToken(response.accessToken);
          } catch (error) {
              if (error.errorCode === "consent_required" || error.errorCode === "interaction_required" || error.errorCode === "login_required") {
                  const response = await instance.acquireTokenSilent(loginRequest);
                  setAccessToken(response.accessToken);
              } else if (error.errorCode === '429') {
                  console.log("Our Service Token Server (STS) is overloaded, please try again in sometime");
              } else {
                  console.log("There was some problem fetching the access token" + error.toString());
              }
          }
      }      
  } catch (error) {
      console.log("An error occurred during authentication:", error.message)
  }
};

const PDFDownload = async () => {
  try {
    setPdfDownloadURl("")
    const { workspace } = await getReportData(region);
    const exportResponse = await fetch(
      `https://api.powerbi.com/v1.0/myorg/reports/${reportId}/ExportTo`,
      {
        method: "POST",
        body: JSON.stringify({ format: "PDF", powerBIReportConfiguration: {
          reportLevelFilters: [{ "filter": `${workspace}/assessment_id eq '${assessementId}' and scenarios_p/scenarios_p eq '${selectedScenario}'`}]
        } }),
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      }
    );

    if (!exportResponse.ok) {
      throw new Error(`Export request failed with status ${exportResponse.status}`);
    }

    const exportData = await exportResponse.json();
    const exportId = exportData.id;

    const checkExportStatus = async () => {
      const statusResponse = await fetch(
        `https://api.powerbi.com/v1.0/myorg/reports/${reportId}/exports/${exportId}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      const statusData = await statusResponse.json();
      const exportStatus = statusData.status;
      if (exportStatus === "Succeeded" || statusData.percentComplete === 100) {
        const PDFDownload = await fetch(
          `https://api.powerbi.com/v1.0/myorg/reports/${reportId}/exports/${exportId}/file`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + accessToken,
            },
          }
        );
        if (!PDFDownload.ok) {
          throw new Error("Failed to download report");
        }
        const blob = await PDFDownload.blob();
        const url = URL.createObjectURL(blob);
        setPdfDownloadURl(url)
      } else {
        setTimeout(checkExportStatus, 500); // Poll every 0.5 second
      }
    };
    // Start the polling
    await checkExportStatus();
  } catch (error) {
    console.log("Error while downloading the PDF:", error);
  }
};

const handlePDFDownload = async () => {
  try{
    setIsDownloaded(true)
    const a = document.createElement("a");
    a.href = pdfDownloadURL;
    a.download = `${projectName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setIsDownloaded(false)
  }catch(error){
    console.log("Some error occured while Downloading the file:", error)
  }
}

    // UseEffect to get Access token //
    useEffect(() => {
      const Authentication = async () => {
        try {
            await authenticate();
        } catch (error) {
            console.log(error.message);
        }
      };
      Authentication();
      const intervalId = setInterval(Authentication, 55 * 60 * 1000); // Run every 55 minutes
      return () => clearInterval(intervalId); // Clear interval on component unmount
    }, []);

     // UseEffect to get Embed URL //
    useEffect(() => {
      const getEmbedURL  = async () => {
        try{
          if (accessToken) {
            const { reportId, workspace } = await getReportData(region);
            setReportId(reportId);
        
            let updatedEmbedUrl = embedUrl;
            if (!embedUrl) {
                updatedEmbedUrl = await getEmbedUrl() + `&filter=${workspace}/assessment_id eq '${assessementId}' and scenarios_p/scenarios_p eq '${selectedScenario}'`;
            } else {
                updatedEmbedUrl += `&filter=${workspace}/assessment_id eq '${assessementId}' and scenarios_p/scenarios_p eq '${selectedScenario}'`;
            }
            setEmbedUrl(updatedEmbedUrl);
          }
        }catch(error){
          console.log("Error obtaining the access token", error);
        }
      };
      getEmbedURL();
    }, [accessToken, region, assessementId, selectedScenario]);

    // UseEffect to get PDF data
    useEffect(() => {
      const DownloadPDF = async() => {
        try{
          if(accessToken){
            await PDFDownload();
          }
        }catch(error){
          console.log("Error in UseEffect while downloading:", error)
        }
      }
      DownloadPDF();
    }, [reportId, accessToken, assessementId, selectedScenario])

    return (
        <div style={{width: "100%", height: "100%" }}>
            {!accessToken && !embedUrl &&
            <div>
              Error while loading the Report. Please Refresh the page
            </div>
            }
            {accessToken && embedUrl && showDownloadButton &&
            <div style={{position: "absolute", right: 45}}>
              {pdfDownloadURL ? null :<CircularProgress size="1.3rem"/>}
              {
                isDownloaded ? 
                  <CircularProgress size="1.3rem" color="success"/>
                  : 
                  pdfDownloadURL? 
                  <Button
                  onClick={handlePDFDownload}
                  variant="contained"
                  color="success"
                  className="pdfDownloadButton"
                  style={{
                    backgroundColor: "#1C96A3",
                    textTransform: "capitalize",
                    fontSize: "0.8rem",
                    padding: "7px 8px",
                    minWidth: 0
                  }}
                >
                    <p style={{margin: 0}}>Download</p>
                  <DownloadForOfflineRoundedIcon style={{ color: '#fff', cursor: 'pointer', fontSize: "1.2rem", }}/> 
                </Button>
                  : null
              } 
            </div>
            }
                <PowerBIEmbed
                  embedConfig={{
                    type: "report", // Supported types: report, dashboard, tile, visual, and qna.
                    id: reportId,
                    embedUrl:embedUrl,
                    accessToken: accessToken,
                    tokenType: models.TokenType.Aad, // Use models.TokenType.Aad if you're embedding for your organization.
                    settings: {
                      navContentPaneEnabled: false,
                      panes: {
                        filters: {
                          expanded: false,
                          visible: false,
                        },
                      },
                    },
                  }}
                  eventHandlers={
                    new Map([
                      [
                        "loaded",
                        function () {
                          // console.log("Report loading time:", Math.round((new Date() - timeStamp)/ 1000),"secs")
                          //   console.log("Report loaded");
                          // console.log("Report Loading time:", timeStampCalc(), "sec");
                        },
                      ],
                      [
                        "rendered",
                        function () {
                          //   console.log("Report rendered");
                          // console.log("Report Rendering time:", Math.round((new Date() - timeStamp)/ 1000), "secs")
                          setShowDownloadButton(true)
                          // console.log("Report Rendering time:", timeStampCalc(), "sec");
                        },
                      ],
                      [
                        "error",
                        function (event) {
                          console.log(event.detail);
                        },
                      ],
                    ])
                  }
                  cssClassName={"Embed-container"}
                  getEmbeddedComponent={(embeddedReport) => {
                    window.report = embeddedReport;
                  }}
                />
        </div>
    );
};

export default PowerBiReports;